import axios, { AxiosError } from 'axios';
import { ApiError } from './api-error';

export const getSwrFetcher = async (url: string) => {
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await axios.get(url, options);

    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      const message = error.response?.data?.message || error.message;
      const statusCode = error.response?.status;
      const details = error.response?.data?.details;

      // Preserve structured error details from backend
      throw new ApiError(`API Error: ${message}`, statusCode, details);
    }

    throw error;
  }
};
